/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModuleCode } from './moduleCode';


export interface SubModuleCode { 
    code?: string;
    createdByName?: string;
    creationTime?: string;
    deleted?: boolean;
    description?: string;
    id?: number;
    moduleCode?: ModuleCode;
    moduleStatus?: SubModuleCode.ModuleStatusEnum;
    updateTime?: string;
    updatedByName?: string;
}
export namespace SubModuleCode {
    export type ModuleStatusEnum = 'ACTIVE' | 'INACTIVE';
    export const ModuleStatusEnum = {
        Active: 'ACTIVE' as ModuleStatusEnum,
        Inactive: 'INACTIVE' as ModuleStatusEnum
    };
}


